import { BotToolChoice, InventoryItem, InventoryModule, InventoryOperation, InventorySelection } from 'game/state/BotState';
import { Processor } from '../Processor';

export const inventoryProcessor: Processor<InventoryModule> = (module, ctx) => {
  if (!module.config.selection) return { status: 'null' };
  const { inventory } = ctx.bot.props.state;
  switch (module.config.selection) {
    case InventorySelection.Water: {
      const wateringCan = inventory.find(item => item.type === BotToolChoice.WateringCan)
        || { type: BotToolChoice.WateringCan, count: 0 };
      const passesTest = module.config.operation === InventoryOperation.Lacks
        ? wateringCan.count === 0
        : wateringCan.count > 0;
      return (passesTest)
        ? { status: 'success', moduleId: module.id, value: { type: 'item', item: wateringCan } }
        : { status: 'null' };
    }
    case InventorySelection.RedHerring: {
      const item: InventoryItem = { type: BotToolChoice.WateringCan, count: 0 };
      return (module.config.operation === InventoryOperation.Lacks)
        ? { status: 'success', moduleId: module.id, value: { type: 'item', item } }
        : { status: 'null' };
    }
  }
};
